import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';
import Upperbox from '../components/Upperbox';

export const Businessreturns = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
       <Upperbox />
       <NavBar />
      <div className='tax-page'>
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">Business Tax Returns</h1>
            <Link to="/businessservicespage" className="tax-notification-body">Go Back</Link>
          </div>
        </div>

        <div className='tax-content-container'>
          <h1 className='tax-section-title'>
            Comprehensive Business Tax Return Services at Sumukha Tax Filers.
          </h1>
          <p className='tax-section-description'>
            Navigating the complexities of business tax returns can be daunting, but Sumukha Tax Filers. is here to streamline the process. Our skilled Certified Public Accountants (CPAs) and Enrolled Agents (EAs) are dedicated to ensuring your business tax returns are completed accurately and in compliance with IRS regulations, allowing you to focus on growing your business.
          </p>
          <h2 className='tax-subheading'>Why Choose a CPA or EA for Your Business Tax Returns?</h2>
          <ul className='tax-section-description'>
            <li><strong>Expertise:</strong> CPAs and EAs possess extensive knowledge of tax laws, ensuring your returns are not only accurate but also optimized to minimize your tax liability.</li>
            <li><strong>Representation:</strong> EAs have the authority to represent clients before the IRS, providing you peace of mind that you have professional support in case of audits or inquiries.</li>
            <li><strong>Comprehensive Services:</strong> Our team is equipped to handle various business structures, including sole proprietorships, partnerships, corporations, and foreign entities.</li>
          </ul>
          <h2 className='tax-subheading'>Our Business Tax Return Services</h2>
          <p className='tax-section-description'>
            At Sumukha Tax Filers., we offer a full range of services for preparing business tax returns, including:
          </p>
          <ol className='tax-section-description'>
            <li><strong>Preparation of Business Tax Forms:</strong>
              <ul>
                <li><strong>Form 1120 :</strong> U.S. Corporation Income Tax Return for corporations.</li>
                <li><strong>Form 1120-S :</strong> U.S. Income Tax Return for an S Corporation.</li>
                <li><strong>Form 1065 :</strong> U.S. Return of Partnership Income for partnerships.</li>
                <li><strong>Form 1120-F :</strong> U.S. Income Tax Return of a Foreign Corporation.</li>
              </ul>
            </li>
            <li><strong>Tax Planning Strategies:</strong> We work with you throughout the year to create a tailored tax strategy that can help reduce your tax liability and improve your overall financial health.</li>
            <li><strong>Compliance Monitoring:</strong> We ensure your business complies with all federal and state tax regulations, helping you avoid potential penalties and audits.</li>
            <li><strong>Entity Structure Analysis:</strong> Our team assists you in evaluating the best business entity for your goals—be it a C Corporation, S Corporation, LLC, Partnership, or foreign corporation—focusing on the tax implications of each.</li>
            <li><strong>Audit Representation and Support:</strong> In the event of an IRS audit, our team will guide you through the process, providing necessary documentation and representing you before the IRS.</li>
            <li><strong>Amended Returns:</strong> If you discover discrepancies in previously filed tax returns, we can assist you in filing amended returns or the appropriate forms for businesses to correct any errors.</li>
          </ol>
          <h2 className='tax-subheading'>Get Started Today</h2>
          <p className='tax-section-description'>
            At Sumukha Tax Filers., we recognize that each business is unique, and we tailor our services to fit your specific needs. With our team of expert CPAs and EAs handling your business tax returns, you can rest assured that you are in good hands. Contact us today to schedule a consultation and experience the difference of professional tax preparation!
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};
export default Businessreturns;